/** Byline placeholder: avatar beside two short text bars. */

import { Pad } from 'component/basics';
import { StyleSheet, View } from 'react-native';

import { BaseSkeleton } from './base-skeleton';
import { TextContainerSkeleton } from './text-container-skeleton';

export function BylineSkeleton() {
    return (
        <View style={BylineSkeletonStyle.container}>
            <BaseSkeleton borderRadius={16} height={32} marginRight={8} width={32} />
            <View>
                <TextContainerSkeleton borderRadius={2} height={6} width={100} />
                <Pad size={8} />
                <TextContainerSkeleton borderRadius={2} height={6} width={40} />
            </View>
        </View>
    );
}

const BylineSkeletonStyle = StyleSheet.create({
    container: { flexDirection: 'row', alignItems: 'center' },
});
